module.exports = __webpack_public_path__ + "media/img/pages/companies/groupe-mutuel-98bdc4b5d6f1280e88603655cef994e2.png";